import React from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { FormattedMessage, FormattedDate } from "react-intl";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

interface MyPageDatePickerProps {
	value: Date;
	minDate?: number | string | Date;
	maxDate?: number | string | Date;
	label?: string;
	onChangeDate: (event: any) => void;
	disablePast?: boolean;
	disableFuture?: boolean;
	maxDateMessage?: React.ReactNode;
}

const MyPageDatePicker = (props: MyPageDatePickerProps) => {
	const { minDate, maxDate, label, onChangeDate, ...rest } = props;

	const today = new Date();

	const shouldDisableDate = (date: MaterialUiPickersDate) => {
		// Return true if the day is a weekend (6: Saturday, 0: Sunday)
		return date.getDay() === 6 || date.getDay() === 0;
	}

	return (
		<KeyboardDatePicker
			label={label || "Velg dato"}
			format="dd.MM.yyyy"
			onChange={onChangeDate}
			DialogProps={{
				onClose: () => { },
			}}
			cancelLabel="Lukk"
			okLabel="Velg"
			minDate={minDate}
			shouldDisableDate={shouldDisableDate}
			minDateMessage={
				<FormattedMessage
					id="minside.DatePicker.minDate-error"
					defaultMessage="Datoen må være etter {minDate}"
					description="The picked date is too early"
					values={{
						minDate: (
							<FormattedDate
								year="numeric"
								month="2-digit"
								day="2-digit"
								value={new Date(minDate || today)}
							/>
						),
					}}
				/>
			}
			maxDate={maxDate}
			maxDateMessage={
				<FormattedMessage
					id="minside.DatePicker.maxDate-error"
					defaultMessage="Datoen må være innen {maxDate}"
					description="The picked date is too late"
					values={{
						maxDate: (
							<FormattedDate
								year="numeric"
								month="2-digit"
								day="2-digit"
								value={new Date(maxDate || today)}
							/>
						),
					}}
				/>
			}
			invalidDateMessage={
				<FormattedMessage
					id="minside.DatePicker.invalidDate-error"
					defaultMessage="Ugyldig datoformat"
					description="Date format is invalid"
				/>
			}
			{...rest}
		/>
	);
};

export default MyPageDatePicker;
